import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from '../../../store';

export default function CreateWallet({ isOpen, setOpenCreateWallet, setOpenImportWallet, createWallet, wallet, confirmPermission, isNewlyCreated }) {
    const { data: { mainWallets, cryptoWallets, masterCard } } = useSelector((state: RootState) => state.assets);
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4 sm:px-6 md:px-8">
            <div className="bg-white rounded-lg shadow-xl p-4 sm:p-6 md:p-8 w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg">
                <div className="flex justify-between items-center">
                    <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4 sm:mb-6">Create {wallet.currency} Wallet</h2>
                    <button className="mb-8"  disabled={isNewlyCreated} onClick={() => {
                        setOpenCreateWallet(false);
                    }}>x</button>

                </div>
                <div className="flex flex-wrap gap-2 justify-end space-x-2">
                    <h2>You can import wallet with private key or seed. Do you want to import wallet, or create?</h2>
                    <div>

                        <button
                            type="button"
                            onClick={() => {
                                setOpenCreateWallet(false)
                                // if (confirmPermission()) {
                                setOpenImportWallet(true)
                                // }
                            }}
                            className="px-4 py-2 text-gray-600 bg-gray-300 rounded-md hover:bg-gray-400 mr-2"
                            disabled={isNewlyCreated}
                            // disabled
                        >
                            Import
                        </button>
                        <button
                            type="button"
                            onClick={() => {
                                createWallet(wallet)
                            }
                            }
                              disabled={isNewlyCreated}
                            className="px-4 py-2 text-white bg-belobaba-gold rounded-md hover:bg-[#a39a22]"
                        >   {isNewlyCreated ? "Creating..." : "Create"}

                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
}